import { emailRegex } from "shared/model/email";
import { TranslationFeKey } from "shared/types/translation-key";
import { z, ZodString } from "zod";

import { T, useT } from "../../../../../../i18n/use-t";
import { ValidationFunction } from "../../lookup";

const createEmailSchema = (t: T = (a) => a?.tx || "") =>
  z
    .string()
    .nonempty({
      message: t({ tx: "auth.signUp.inputs.email.fieldMissingError" }),
    })
    .regex(emailRegex, {
      message: t({ tx: "auth.signUp.inputs.email.notAnEmailError" }),
    });

export const useEmailValidationSchema = (): ZodString => {
  const t = useT();
  return createEmailSchema(t);
};

export const emailValidation: ValidationFunction = (value) => {
  const result = createEmailSchema().safeParse(value);

  if (!result.success) {
    const tx = result.error.errors[0].message as TranslationFeKey;

    return {
      ok: false,
      message: { tx },
    };
  }

  return {
    ok: true,
  };
};
